const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    SETUP_USER: true,
});
